import UserRow from './UserRow';
import AxiosClient from '../../assets/AxiosClient.js';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Loader from '../../assets/tools/Loder/loader';
import { DataTable, PageHeader, PageToolbar } from '../../componants/Workspace';

const Users = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 40;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosClient.get('/Users');
        const { users } = await response.data;
        setUsers(users);
        setFilteredUsers(users);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const filtered = users.filter(
      (user) =>
        user.first_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.last_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.email.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredUsers(filtered);
    setCurrentPage(1);
  }, [searchQuery, users]);

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <PageHeader
        title="Users"
        description="Manage workspace accounts and access roles."
        actions={(
          <Link className="btn btn-primary" to="Add">
            <i className="material-icons" aria-hidden="true">person_add</i>
            Add user
          </Link>
        )}
      />
      <PageToolbar
        filters={(
          <input
            type="search"
            className="form-control workspace-search"
            aria-label="Search users by name or email"
            placeholder="Search by name or email"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        )}
      />
      <DataTable>
            <thead>
              <tr>
                <th className="text-uppercase font-weight-bolder opacity-7">Full name</th>
                <th className="text-uppercase font-weight-bolder opacity-7 ps-2">Title</th>
                <th className="text-uppercase font-weight-bolder opacity-7 ps-2">Action</th>
              </tr>
            </thead>
            {!loading ? (
              <tbody>
                {currentUsers.map((user) => (
                  <UserRow key={user.id} name={`${user.first_name} ${user.last_name}`} title={user.role} id={user.id} />
                ))}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td colSpan="3"><Loader label="Loading users..." /></td>
                </tr>
              </tbody>
            )}
      </DataTable>

      {!loading && filteredUsers.length > usersPerPage && (
        <nav className="workspace-pagination" aria-label="User pages">
          <ul className="pagination mb-0">
            {Array.from({ length: Math.ceil(filteredUsers.length / usersPerPage) }, (_, i) => (
              <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                <button className="page-link" onClick={() => paginate(i + 1)} aria-current={currentPage === i + 1 ? 'page' : undefined}>
                  {i + 1}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </>
  );
};

export default Users;